import { Link, type LinkProps } from "@tanstack/react-router";
import type React from "react";

interface CustomLinkProps extends LinkProps {
    className?: string;
    onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

export const CustomLink = (props: CustomLinkProps) => {
    /**
     * append the uid query param to every CustomLink
     */
    const { className, ...linkProps } = props;
    const urlParams = new URLSearchParams(window.location.search);
    const uid = urlParams.get("uid");
    if (uid) {
        let newSearch = { uid };
        if (typeof linkProps.search === "object") {
            newSearch = { ...newSearch, ...linkProps.search };
        }
        return <Link {...linkProps} search={newSearch} className={className} />;
    }
    return <Link {...linkProps} className={className} />;
};
